<template>
  <div class="container">
    <van-nav-bar :title="$t('infomation.title')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main-content">

          <div class="item van-hairline--bottom">
            <div class="left">{{ $t("infomation.head") }}</div>
            <van-uploader  :after-read="handleelchange"  :auto-upload="false">
              <div class="right">
                <img  :src="this.userInfo.header_img">
                <van-icon name="arrow" />
              </div>
            </van-uploader>
          </div>
        <van-popup v-model="show" position="bottom" round :style="{ height: '50%' }">
            <div class="avatarbox">
                <div class="title van-hairline--bottom">
                  <van-icon @click="show=false" name="cross" />
                  <div class="text">{{ $t("infomation.select") }}</div>
                  <div class="btnok" @click="check()">{{ $t("msg.确定") }}</div>
                </div>
                <div class="content">
                  <van-image
                      round
                      v-for="(item,index) in 185" :key="index"
                      @click="select_header_img('https://zxbuk.oss-cn-hongkong.aliyuncs.com/images/avatar/avatar'+item+'.png')"
                      :class="{ 'choose': isActive ===  'https://zxbuk.oss-cn-hongkong.aliyuncs.com/images/avatar/avatar'+item+'.png'}"
                      :src="'https://zxbuk.oss-cn-hongkong.aliyuncs.com/images/avatar/avatar'+item+'.png'"
                  />
                </div>
            </div>
        </van-popup>
        <div class="item van-hairline--bottom" @click="toSetName()">
        <div class="left">{{ $t("infomation.name") }}</div>
        <div class="right">
          <span class="desc">{{this.userInfo.name ? this.userInfo.name :$t('msg.未设置')}}</span>
          <van-icon name="arrow" />
        </div>
      </div>
        <div class="item van-hairline--bottom" @click="toSetSex()">
        <div class="left">{{ $t("infomation.sex") }}</div>
        <div class="right">
          <span class="desc">{{this.userInfo.sex !== "0" ? this.userInfo.sex === "1" ? $t("infomation.man") :$t("infomation.girl"): $t("infomation.unknown")}}</span>
          <van-icon name="arrow" />
        </div>
      </div>
        <div class="item van-hairline--bottom" @click="toSetBank()">
        <div class="left">{{ $t("infomation.binding") }}</div>
        <div class="right">
          <span class="desc">{{this.isBank ? $t("msg.已绑定") :$t("msg.无")}}</span>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive:false,
      show:false,
      isBank:false,
      userInfo:{}
    };
  },
  methods: {
    handleelchange(file) {
      const formDatas = new FormData();
      formDatas.append("file",file.file);
      console.log(formDatas.get('file'))
      //axios.post("http://video.com/api/video/doupload", formDatas).then(res => { console.log(res) })
      this.$http({
        method: 'post',
        data:formDatas,
        url: 'user_header_upload'
      }).then(res=>{
        if(res.code === 200){
          this.select_header_img(res.data);
          this.check();
        }

      })
    },
    back(){
      return window.history.back();
    },
    toSetName(){
      this.$router.push({path:'/Setname'});
    },
    toSetBank(){
      this.$router.push({path:'/Setbank'});
    },
    toSetSex(){
      this.$router.push({path:'/Setsex'});
    },
    openHerderImg(){
      this.show = true;
    },
    select_header_img(url){
        this.isActive = url;
    },
    check(){
      this.$http({
        method: 'get',
        data:{header_img:this.isActive},
        url: 'user_header_img'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.show = false;
        }

        this.$toast(this.$t("msg."+res.msg));
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          //this.$toast(res.msg);
        }
      })
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.isBank = true;
          }else {
            this.isBank = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container .main-content {
  padding: 0 10PX;
  background-color: #fff;
}
.container .main-content .item{
  padding: 15PX 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 16PX;
}
.container .main-content .item .right{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.container .main-content .item .right img{
  width: 45PX;
}
.container .main-content .van-hairline--bottom::after {
  border-bottom-width: 3PX;
}
.container .main-content .item .right .desc-cell-number, .container .main-content .item .right .desc{
  font-size: 16PX;
  font-weight: 700;
  color: #979799;
}
.avatarbox{
  padding: 7PX;
  color: #000;
  height: 81%;
  background-color: #fff;
}
.avatarbox .title{
  padding: 8PX 10PX 10PX;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 16PX;
}

.avatarbox .content .van-image{
  width: 50PX;
  height: 50PX;
  margin: 2.5%;
  border-radius: 50%;
}
.avatarbox .content{
  padding-bottom: 10PX;
  height: 100%;
  overflow-y: auto;
  padding-top: 10PX;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.avatarbox .content .choose{
  width: 40PX;
  height: 40PX;
  border: 3PX solid #e6c3a1;
}
</style>
